import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';
import { GuildMenuItem } from "../../components/misc/GuildMenuItems"
import { useFetchGuild } from "../../utils/hooks/useFetchGuild"
import { GuildContext } from '../../utils/contexts/GuildContext';
import { IoIosMusicalNotes } from "react-icons/io";
import { Guild } from '../../utils/types';
import styles from './index.module.scss'
import player from './player.module.scss'
import add from './add.module.scss'
import { Spinner } from '../../components/misc/Spinner'
import { BiAddToQueue } from "react-icons/bi";


const MenuPage = () => {
  const { guilds, loading } = useFetchGuild();
  const navigate = useNavigate();
  const { updateGuild } = useContext(GuildContext);

  const handleClick = (guild: Guild) => {
    updateGuild(guild);
    navigate(`/dashboard/categories`);
  };

  const playerClick = () => {
    navigate(`/player/select`);
  }

  const inviteClick = () => {
    navigate(`/invite`);
  }

  if (loading) return <Spinner children={<MoonLoader size={40} color="white" />} />;

  return (
    <div>
      <div className="page">
          <div className={styles.container}>
              <head>
                  <title>Menu</title>
                  <meta name="viewport" content="initial-scale=1.0, width=device-width" />
              </head>

              <h1 className={styles.title}>Please Select a Server</h1>
              <div onClick={() => playerClick()}>
                <div className={player.container}>
                    <IoIosMusicalNotes size={55} color="#ffffff"/>
                    <div className={player.line}/>
                    <p className={player.text}>{"Player Room [BETA]"}</p>
                </div>
              </div>
              {guilds && guilds.map((guild) => (
                  <div key={guild.id} onClick={() => handleClick(guild)}>
                    <GuildMenuItem guild={guild}/>
                  </div>
              ))}
              <div onClick={() => inviteClick()}>
                <div className={add.container}>
                    <BiAddToQueue size={55} color="#ffffff"/>
                    <div className={add.line}/>
                    <p className={add.text}>{"Invite your bot to new guild!"}</p>
                </div>
              </div>
          </div>
      </div>
    </div>
  )
  
}

export default MenuPage